type FlatCharacter = {
    characterType: Stories.CharacterType;
    name: string;
    want?: string;
    need?: string;
    change?: string;
    description?: string;
    role?: Stories.CharacterRole;
};

export const mapStoryDataForApi = (data: Partial<Stories.Create | Stories.Edit>): Partial<Stories.Create | Stories.Edit> => {
  if (!data.characters) {
    return data;
  }

  const { protagonist, antagonist, supportcharacters } = data.characters;
  const charactersList: FlatCharacter[] = [];

  if (protagonist && protagonist.name) {
    charactersList.push({
      characterType: 'protagonist' as Stories.CharacterType,
      name: protagonist.name,
      want: protagonist.want,
      need: protagonist.need,
      change: protagonist.change,
    });
  }
  if (antagonist && antagonist.name) {
    charactersList.push({
      characterType: 'antagonist' as Stories.CharacterType,
      name: antagonist.name,
      description: antagonist.description,
    });
  }

  if (supportcharacters && supportcharacters.length > 0) {
    supportcharacters.forEach(character => {
      charactersList.push({
        characterType: 'support' as Stories.CharacterType,
        name: character.name,
        description: character.description,
        role: character.role,
      });
    });
  }

  const transformedData = { ...data };
  transformedData.characters = charactersList.length > 0 ? (charactersList as unknown as Stories.StoryCharacters) : undefined;

  return transformedData;
};
